/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import config from '../config/updateProfile.config.json';

import axios from 'axios';
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { UPDATE_MY_PROFILE } from '../graphql';
import { VApplication } from '../../../../application';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { UploadDocService } from '@services/uploadService';

const uploadDocServ = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.UploadDocService') as UploadDocService;
};

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

export interface IUpdateProfileMethods extends IPluginMethodMap {
  getUpdateProfile(args: any): Promise<any>;
}

export interface UpdateProfileProps {
  name: string;
  description: string;
  telephone: string;
  address: string;
  city: string;
  country: string;
  profileImage: any;
}

export class UpdateProfileService implements IAgentPlugin {
  readonly methods: IUpdateProfileMethods;

  constructor() {
    this.methods = {
      getUpdateProfile: this.getUpdateProfile.bind(this),
    };
  }

  async getUpdateProfile(args: UpdateProfileProps) {
    console.log('data in mutation', args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient('graphql-gateway');
    const storageService = StorageModule?.getInstance();
    const profileDetails = storageService?.get('myProfile', 'local');
    const localProfIdId = profileDetails?.id;
    let logo: any;
    if (args?.profileImage?.base64) {
      logo = await uploadDocServ().uploadDoc(args?.profileImage?.base64);
    }
    try {
      if (client) {
        const res = await client.mutate({
          mutation: UPDATE_MY_PROFILE,
          variables: {
            where: {
              id: localProfIdId,
            },
            update: {
              name: args?.name,
              city: args?.city,
              country: args?.country,
              phoneNo: args?.telephone,
              logo: logo?.url,
              description: args?.description,
              address: args?.address,
            },

            // updateMyProfileInput2: {
            //   firstName: args?.firstName,
            //   lastName: args?.lastName,
            //   occupation: args?.occupation,
            //   primaryContactNo: args?.telephone,
            //   address: {
            //     addressLine1: args?.address,
            //     city: args?.city,
            //     country: args?.country,
            //   },
            //   image: args?.profileImage?.base64,
            // },
          },
          fetchPolicy: 'no-cache',
        });
        if (res?.data) {
          return {
            data: res?.data,
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
    return { data: config };
  }
}
